import React from 'react';
import { Translate } from 'react-jhipster';

// import MenuItem from '../../../../app/shared/layout/menus/menu-item';
import MenuItem from '../shared/layout/menus/menu-item';

const EntitiesMenu = () => {
  const allMenuItems = [
    {
      id: '1',
      key: 'my-help-resources',
      name: 'My Help Resources',
      imageUrl: 'content/images/cases/resource.svg',
      to: '/case-help-resource',
      contentKey: 'global.menu.entities.my-help-resources',
    },
    // {
    //   id: '2',
    //   key: 'my-case-Referrals',
    //   name: 'My Case Referrals',
    //   imageUrl: 'content/images/cases/case referals.png',
    //   to: '/plan',
    //   contentKey: 'global.menu.entities.my-case-Referrals',
    // },
    // {
    //   id: '3',
    //   key: 'my-case-reports',
    //   name: 'My Case Reports',
    //   imageUrl: 'content/images/cases/casereport.png',
    //   to: '/plan',
    //   contentKey: 'global.menu.entities.case-referalls',
    // },
  ];

  return (
    <>
      {allMenuItems.map(item => (
        <div key={item.key}>
          <div className="nav-menu-items" style={{ cursor: item.to ? 'pointer' : 'default' }}>
            <MenuItem to={item.to} id={item.id} imageUrl={item.imageUrl}>
              {item.name}
              {/* <Translate contentKey={item.contentKey} /> */}
            </MenuItem>
          </div>
        </div>
      ))}
    </>
  );
};

export default EntitiesMenu;
